import * as THREE from 'three';
import type { RefObject } from 'react';
import { useFrame } from '@react-three/fiber';
// Shared Uniforms
const occlusionUniforms = {
    playerPos: { value: new THREE.Vector3(0, 0, 0) },
    cameraPos: { value: new THREE.Vector3(0, 0, 0) }
};

// Hook to update uniforms frame-by-frame
export function useOcclusionUpdater(playerRef: RefObject<THREE.Object3D | null>) {
    useFrame((state) => {
        if (playerRef.current) {
            occlusionUniforms.playerPos.value.copy(playerRef.current.position);
        }
        occlusionUniforms.cameraPos.value.copy(state.camera.position);
    });
}

// Function to patch materials
export function applyOcclusionFade(material: THREE.Material) {
    void material;
}
